import { render, staticRenderFns } from "./operate.vue?vue&type=template&id=62729a6a&scoped=true"
import script from "./operate.vue?vue&type=script&lang=js"
export * from "./operate.vue?vue&type=script&lang=js"
import style0 from "./operate.vue?vue&type=style&index=0&id=62729a6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62729a6a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StyleSelector: require('C:/Users/xiao9/Desktop/projects/web-tattoo-workspace/components/styleSelector.vue').default,AspectRatioSelector: require('C:/Users/xiao9/Desktop/projects/web-tattoo-workspace/components/aspectRatioSelector.vue').default})
